import React from 'react';
import styles from './loading.module.css';

export type LoadingProps = {
  className?: string
};

export function Loading({ className = '' }: LoadingProps) {
  return (
    <svg className={`${styles.loading} ${className}`} viewBox="0 0 200 200" preserveAspectRatio="xMidYMid meet">
      <circle id="loading-circle-4" cx={50} cy={50} r={35} fill="rgba(143, 89, 255)" fillOpacity={0.2} />
      <circle id="loading-circle-3" cx={50} cy={50} r={35} fill="rgba(143, 89, 255)" fillOpacity={0.4} />
      <circle id="loading-circle-2" cx={50} cy={50} r={35} fill="rgba(143, 89, 255)" fillOpacity={0.7} />
      <circle id="loading-circle-1" cx={50} cy={50} r={35} fill="rgba(143, 89, 255)" />
    </svg>

  );
}
